import { useMutation, useQueryClient } from "@tanstack/react-query";
import { uploadDocuments } from "@/api";

export const useUploadDocuments = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      documentType,
      dealIdStr,
      files,
      customFileName,
      clientId,
    } : {
      documentType: string
      dealIdStr: string
      files: File[]
      customFileName?: string
      clientId?: number
    }) => uploadDocuments({ documentType, dealIdStr, files, customFileName, clientId }),
    
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["dropboxDocuments", parseInt(variables.dealIdStr ?? "0")] });
    },
  });
};
